import { ComposedModal, ModalHeader } from "carbon-components-react";

import { useParams } from "react-router-dom";
import QuizQuestionOptionForm from "forms/QuizQuestionOptionForm/QuizQuestionOptionForm";

const ModalQuizQuestionOption = ({ questionId, ...props }) => {

    const { event } = useParams()

    const form = props.open ? (
        <QuizQuestionOptionForm
            event={event}
            questionId={questionId}
            modal={true}
            onRequestClose={props.onClose}
            onSubmit={props.onSubmit}
            hasForm={true}
            itemId={props.defaultValues?.id}
            defaultValues={props.defaultValues}
        />
    ) : null

    return (
        <ComposedModal
            size='sm'
            open={props.open}
            onClose={props.onClose}
        >
            <ModalHeader
                title={"Question option"}
                buttonOnClick={props.onClose} />
            {form}
        </ComposedModal>
    )
}

export default ModalQuizQuestionOption